export const MIGRATION_MODULE = 'migration'
export const SIMULATE_MIGRATION = 'SIMULATE_MIGRATION'
export const EXEC_MIGRATION = 'EXEC_MIGRATION'
export const SET_MIGRATION_RESULT = 'SET_MIGRATION_RESULT'
export const GET_MIGRATION_RESULT = 'GET_MIGRATION_RESULT'